
import { Vue, Component, Prop,Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "NSelect",
  components: {
  },
})
export default class NSelect extends BaseVue {
  @Model('on-change') defaultValue!: any
  @Prop({ default: () => [] }) options!: any; //下拉列表列表数据
  // @Prop({ default: () => "" }) value!: any; //下拉列表值
  @Prop({ default: () => false }) disabled!: Boolean; //是否禁用
  @Prop({ default: () => "" }) name!: String; //下拉列表name
  @Prop({ default: () => true }) transfer!: Boolean; //下拉列表transfer   置于body内
  @Prop({ default: () => false }) clearable!: Boolean; //下拉列表clearable 清除
  @Prop({ default: () => "请选择" }) placeholder!: String; //下拉列表placeholder
  @Prop({ default: () => true }) filterable!: Boolean; //下拉列表filterable 搜索
  @Prop({ default: () => false }) multiple!: Boolean; //是否多选
  @Prop({ default: () => false }) allowCreate!: Boolean; //是否允许用户创建新条目，需开启 filterable
  @Prop({ default: () => false }) labelInValue!: Boolean;
  mounted() {
  }
  onSelect(value){
    this.$emit("on-select",value)
  }
  onChange(value){
    // vue 原生的方法 return 出去
    this.$emit("on-change",value)
    // 当前model 赋值
    // this.defaultValue = value;
  }
  onCreate(val){
    this.options.push({
      value: val,
      text: val
    });
  }

}
